import { UsersService } from '@/services/users.service'
import { CallIoService } from '@/services/callio.service'

export default {
  getCurrent({ commit }) {
    return UsersService.getCurrent()
      .then()
      .catch(error =>
        commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      )
  },

  dataEditStaff({ commit }, data) {
    commit('SET_DATA_EDITS_STAFF', data)
  },

  clear({ commit }) {
    commit('CLEAR_DATA')
  },

  async getCallResultStatus({ commit }, params) {
    try {
      const response = await CallIoService.getResultStatusCall(params)
      if (response && response.data) {
        // Transform the response data to select options format
        const options = [
          { id: '0', text: 'Tất cả' },
          ...response.data.map(item => ({
            id: item.code,
            text: item.value,
          })),
        ]
        commit('SET_CALLIO_RESULT_OPTIONS', options)
      }
      return response
    } catch (error) {
      commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      throw error
    }
  },
}
